<template>
  <ValidationProvider v-slot="{ errors }" :name="label" :rules="rules">
    <b-field :type="{ 'is-danger': errors.length > 0 }" :message="errors[0]">
      <template slot="label">
        {{ label }}
        <!-- <sup v-if="rules && rules.includes('required')" class="has-text-danger"
          >(required)</sup
        > -->
        <b-tooltip v-if="tooltip" type="is-dark" :label="tooltip" multilined>
          <b-icon size="is-small" icon="help-circle-outline"></b-icon>
        </b-tooltip>
      </template>
      <b-datepicker
        v-model="item"
        :date-formatter="formatDate"
        v-bind="$attrs"
        icon="calendar-today"
        v-on="$listeners"
        @input="$emit('input', item)"
      />
    </b-field>
  </ValidationProvider>
</template>

<script>
import { format } from 'date-fns'

export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null
    },
    tooltip: {
      type: String,
      default: null
    },
    rules: {
      type: String,
      default: null
    },
    value: {
      type: [Date, String]
    }
  },
  data() {
    return {
      item: this.setDate(this.value)
    }
  },
  watch: {
    value(value) {
      this.item = this.setDate(value)
    }
  },
  methods: {
    formatDate(date) {
      return format(date, 'dd/MM/yyyy')
    },
    setDate(value) {
      if (typeof value === 'string') {
        return new Date(value)
      }
      return value
    }
  }
}
</script>
